import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CampeonatosService } from '../services/campeonatosService';
import { TabelasPesoService } from '../services/tabelasPesoService';
import { inscricoesAPI, categoriasAPI, chavesAPI } from '../services/api';
import './ListaCampeonatos.css';
import './Financeiro.css';
import './CampeonatoDetalhe.css';

const BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace('/api', '');

const CORES_FAIXA = {
  Branca: '#E7E4D6', Cinza: '#9CA3AF', Amarela: '#E8B923', Laranja: '#E8791F',
  Verde: '#2F9E44', Azul: '#1F4FD8', Roxa: '#7C3AED', Marrom: '#7C4A26', Preta: '#15140F',
};
function iniciais(nome) {
  const partes = (nome || '').trim().split(/\s+/);
  return ((partes[0]?.[0] || '') + (partes[1]?.[0] || '')).toUpperCase();
}
const fmtData = (d) => {
  if (!d) return '—';
  const [ano, mes, dia] = d.slice(0, 10).split('-');
  return new Date(ano, mes - 1, dia).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
const fmtMoeda = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',')}`;

const STATUS_OPTIONS = [
  { value: 'INSCRIÇÕES ABERTAS', label: '🟢 Inscrições Abertas', color: '#10B981' },
  { value: 'INSCRIÇÕES ENCERRADAS', label: '🔴 Inscrições Encerradas', color: '#EF4444' },
  { value: 'EM ANDAMENTO', label: '🟡 Em Andamento', color: '#F59E0B' },
  { value: 'FINALIZADO', label: '⚫ Finalizado', color: '#6B7280' },
  { value: 'CANCELADO', label: '❌ Cancelado', color: '#DC2626' },
];
const STATUS_MAP = Object.fromEntries(STATUS_OPTIONS.map((s) => [s.value, s]));
const FORMAS_PAG_TODAS = ['PIX', 'Cartão de Crédito', 'Boleto Bancário', 'Transferência', 'Dinheiro'];

const TOP_TABS = [
  { key: 'visao', label: '📋 Visão Geral' },
  { key: 'inscricoes', label: '✅ Inscrições' },
  { key: 'financeiro', label: '💳 Financeiro' },
  { key: 'categorias', label: '⚖️ Categorias' },
  { key: 'chaves', label: '🔀 Chaves' },
  { key: 'cronograma', label: '🗓 Cronograma' },
  { key: 'editar', label: '✏️ Editar' },
];
const EDIT_SUBTABS = [
  { key: 'dados', label: 'Dados Gerais' },
  { key: 'capa', label: 'Capa / Banner' },
  { key: 'premiacoes', label: 'Premiações' },
  { key: 'lotes', label: 'Lotes' },
  { key: 'edital', label: 'Edital' },
  { key: 'contato', label: 'Contato' },
  { key: 'logistica', label: 'Logística' },
  { key: 'config', label: 'Config.' },
];

function Toast({ toast }) {
  if (!toast.show) return null;
  return <div className={`lc-toast lc-toast-${toast.type}`}>{toast.message}</div>;
}

function CampeonatoDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [camp, setCamp] = useState(null);
  const [tabelasPeso, setTabelasPeso] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [inscritos, setInscritos] = useState([]);
  const [chaves, setChaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  const [activeTab, setActiveTab] = useState('visao');
  const [editSubTab, setEditSubTab] = useState('dados');
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [confirmandoId, setConfirmandoId] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  // ── Form de edição (espelha o antigo EditDrawer) ──
  const [form, setForm] = useState(null);
  const [premiacoes, setPremiacoes] = useState([]);
  const [lotes, setLotes] = useState([]);
  const [cronograma, setCronograma] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [capaFile, setCapaFile] = useState(null);
  const [capaPreview, setCapaPreview] = useState('');

  // ── Chaves: gerador inline ──
  const [gerarCategoriaId, setGerarCategoriaId] = useState('');
  const [gerarFaixa, setGerarFaixa] = useState('');
  const [gerando, setGerando] = useState(false);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 4000);
  };

  const carregarTudo = useCallback(async () => {
    try {
      const [campData, tabelas, catsRes, inscRes, chavesRes] = await Promise.all([
        CampeonatosService.buscarPorId(id),
        TabelasPesoService.listar(),
        categoriasAPI.getAll(),
        inscricoesAPI.listarPorCampeonato(id),
        chavesAPI.getAll(),
      ]);
      setCamp(campData);
      setTabelasPeso(tabelas);
      setCategorias(catsRes.data);
      setInscritos(inscRes.data);
      setChaves(chavesRes.data.filter((c) => c.campeonato_id === id));

      setForm({
        nome: campData.nome || '',
        data_inicio: campData.data_inicio ? campData.data_inicio.split('T')[0] : '',
        data_fim: campData.data_fim ? campData.data_fim.split('T')[0] : '',
        local: campData.local || '',
        cidade: campData.cidade || '',
        estado: campData.estado || '',
        status: campData.status || 'INSCRIÇÕES ABERTAS',
        tabela_peso_id: campData.tabela_peso_id || '',
        edital: campData.edital || '',
        contato_whatsapp: campData.contato_whatsapp || '',
        contato_email: campData.contato_email || '',
        contato_instagram: campData.contato_instagram || '',
        site_oficial: campData.site_oficial || '',
        regulamento_url: campData.regulamento_url || '',
        regras: campData.regras || '',
        info_checkin: campData.info_checkin || '',
        info_pesagem: campData.info_pesagem || '',
        limite_inscricoes: campData.limite_inscricoes || '',
        chave_pix: campData.chave_pix || '',
        observacoes: campData.observacoes || '',
      });
      setPremiacoes(Array.isArray(campData.premiacoes) ? campData.premiacoes : []);
      setLotes(Array.isArray(campData.lotes_inscricao) ? campData.lotes_inscricao : []);
      setCronograma(Array.isArray(campData.cronograma) ? campData.cronograma : []);
      setFormasPagamento(Array.isArray(campData.formas_pagamento) ? campData.formas_pagamento : []);
      setCapaPreview(campData.capa_url ? `${BASE_URL}${campData.capa_url}` : '');
      setCapaFile(null);
    } catch (err) {
      setErro('Não foi possível carregar este campeonato.');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { carregarTudo(); }, [carregarTudo]);

  if (loading) return <div className="campeonatos-loading">Carregando campeonato...</div>;
  if (erro || !camp || !form) {
    return (
      <div className="empty-state">
        <span className="empty-icon">🏆</span>
        <h3>Campeonato não encontrado</h3>
        <p>{erro}</p>
        <button className="btn-primary" onClick={() => navigate('/campeonatos')}>← Voltar para Campeonatos</button>
      </div>
    );
  }

  const statusInfo = STATUS_MAP[camp.status] || STATUS_OPTIONS[0];

  // ── Estatísticas (derivadas das inscrições já carregadas) ──
  const confirmadas = inscritos.filter((i) => i.status === 'confirmada');
  const pendentes = inscritos.filter((i) => i.status === 'pendente_pagamento');
  const canceladas = inscritos.filter((i) => i.status === 'cancelada');
  const receitaConfirmada = confirmadas.reduce((s, i) => s + parseFloat(i.valor_total || 0), 0);
  const receitaPendente = pendentes.reduce((s, i) => s + parseFloat(i.valor_total || 0), 0);
  const ticketMedio = confirmadas.length > 0 ? receitaConfirmada / confirmadas.length : 0;
  const porFormaPagamento = confirmadas.reduce((acc, i) => {
    const chave = i.forma_pagamento || 'Não informado';
    acc[chave] = (acc[chave] || 0) + parseFloat(i.valor_total || 0);
    return acc;
  }, {});
  const totalPorForma = Object.values(porFormaPagamento).reduce((a, b) => a + b, 0) || 1;

  // ── Categorias com contagem de inscritos confirmados ──
  const categoriaContagem = (categoriaId) =>
    confirmadas.filter((i) => (i.categorias || []).some((c) => c.categoria_id === categoriaId)).length;
  const categoriasComInscritos = categorias
    .map((cat) => ({ ...cat, confirmados: categoriaContagem(cat.id) }))
    .filter((cat) => cat.confirmados > 0)
    .sort((a, b) => b.confirmados - a.confirmados);

  // ── Handlers de edição (form) ──
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleCapaChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCapaFile(file);
    setCapaPreview(URL.createObjectURL(file));
  };
  const handleSave = async () => {
    if (!form.nome.trim()) {
      showToast('O nome do campeonato é obrigatório.', 'error');
      return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      fd.append('premiacoes', JSON.stringify(premiacoes));
      fd.append('lotes_inscricao', JSON.stringify(lotes));
      fd.append('cronograma', JSON.stringify(cronograma));
      fd.append('formas_pagamento', JSON.stringify(formasPagamento));
      if (capaFile) fd.append('capa', capaFile);

      await CampeonatosService.atualizar(camp.id, fd);
      showToast('✅ Campeonato atualizado com sucesso!', 'success');
      carregarTudo();
    } catch (err) {
      showToast('❌ Erro ao salvar. Tente novamente.', 'error');
    } finally {
      setSaving(false);
    }
  };
  const handleDelete = async () => {
    setSaving(true);
    try {
      await CampeonatosService.remover(camp.id);
      navigate('/campeonatos');
    } catch (err) {
      showToast('❌ Erro ao excluir campeonato.', 'error');
      setSaving(false);
    }
  };

  const handleConfirmarPagamento = async (inscricaoId) => {
    setConfirmandoId(inscricaoId);
    try {
      const { data } = await inscricoesAPI.confirmar(inscricaoId);
      setInscritos((lista) => lista.map((i) => (i.id === inscricaoId ? data : i)));
      showToast('✅ Pagamento confirmado!', 'success');
    } catch (err) {
      showToast('❌ Erro ao confirmar pagamento.', 'error');
    } finally {
      setConfirmandoId(null);
    }
  };

  // ── Chaves: gerador inline ──
  const categoriaSelecionada = categorias.find((c) => c.id === gerarCategoriaId);
  const faixasDaCategoria = categoriaSelecionada?.faixas || [];
  const atletasDisponiveis = gerarCategoriaId
    ? confirmadas
        .filter((i) => (i.categorias || []).some((c) => c.categoria_id === gerarCategoriaId))
        .filter((i) => !gerarFaixa || i.faixa === gerarFaixa)
    : [];
  const chaveJaExiste = (categoriaId, faixa) =>
    chaves.some((ch) => ch.categoria_id === categoriaId && (faixa ? ch.faixa === faixa : !ch.faixa));

  const handleGerarChave = async () => {
    if (!gerarCategoriaId) return;
    if (atletasDisponiveis.length < 3) {
      showToast('⚠️ Mínimo de 3 atletas confirmados nessa categoria/faixa.', 'error');
      return;
    }
    setGerando(true);
    try {
      await chavesAPI.gerar({ campeonatoId: camp.id, categoriaId: gerarCategoriaId, faixa: gerarFaixa || undefined });
      showToast('✅ Chave gerada com sucesso!', 'success');
      setGerarCategoriaId('');
      setGerarFaixa('');
      carregarTudo();
    } catch (err) {
      showToast(err.response?.data?.error || '❌ Erro ao gerar chave.', 'error');
    } finally {
      setGerando(false);
    }
  };

  const handleVerChave = async (chave) => {
    try {
      const response = await chavesAPI.getHtml(chave.id);
      const blob = new Blob([response.data], { type: 'text/html' });
      window.open(URL.createObjectURL(blob), '_blank');
    } catch {
      showToast('❌ Erro ao abrir a chave.', 'error');
    }
  };
  const handleBaixarChave = async (chave) => {
    try {
      const response = await chavesAPI.getPdf(chave.id);
      const blob = new Blob([response.data], { type: 'text/html' });
      window.open(URL.createObjectURL(blob), '_blank');
    } catch {
      showToast('❌ Erro ao baixar a chave.', 'error');
    }
  };

  const mostrarBarraSalvar = activeTab === 'editar' || activeTab === 'cronograma';

  return (
    <div className="cd-page">
      <Toast toast={toast} />

      <button className="cd-voltar" onClick={() => navigate('/campeonatos')}>← Todos os campeonatos</button>

      {/* ── HERO ── */}
      <div
        className="cd-hero"
        style={camp.capa_url ? { backgroundImage: `linear-gradient(180deg, rgba(21,20,15,.35) 0%, rgba(21,20,15,.88) 100%), url("${BASE_URL}${camp.capa_url}")`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}
      >
        {!camp.capa_url && <div className="cd-hero-grid" />}
        <div className="cd-hero-top">
          <span className="cd-hero-status" style={{ '--status-color': statusInfo.color }}>
            <i /> {camp.status}
          </span>
          <div className="cd-hero-actions">
            <button className="cd-delete-header-btn" onClick={() => setConfirmDelete(true)}>🗑️ Excluir</button>
          </div>
        </div>
        <h1 className="cd-hero-title">{camp.nome}</h1>
        <div className="cd-hero-meta">
          <span>📅 {fmtData(camp.data_inicio)} → {fmtData(camp.data_fim)}</span>
          <span>📍 {camp.local}{camp.cidade ? ` — ${camp.cidade}/${camp.estado}` : ''}</span>
          {camp.tabela_peso_nome && <span>⚖️ {camp.tabela_peso_nome}</span>}
        </div>

        <div className="cd-hero-stats">
          <div className="cd-stat"><span>Inscritos</span><b>{inscritos.length}</b></div>
          <div className="cd-stat"><span>Confirmados</span><b>{confirmadas.length}</b></div>
          <div className="cd-stat"><span>Pendentes</span><b className={pendentes.length > 0 ? 'amber' : ''}>{pendentes.length}</b></div>
          <div className="cd-stat"><span>Arrecadado</span><b>{fmtMoeda(receitaConfirmada)}</b></div>
          <div className="cd-stat"><span>Chaves geradas</span><b>{chaves.length}</b></div>
        </div>
      </div>

      {confirmDelete && (
        <div className="ed-delete-banner cd-delete-banner">
          <span>⚠️ Excluir <strong>{camp.nome}</strong>? Essa ação não pode ser desfeita.</span>
          <div className="ed-delete-banner-actions">
            <button className="ed-cancel-btn" onClick={() => setConfirmDelete(false)} disabled={saving}>Cancelar</button>
            <button className="ed-delete-btn" onClick={handleDelete} disabled={saving}>
              {saving ? 'Excluindo...' : '✓ Sim, excluir'}
            </button>
          </div>
        </div>
      )}

      {/* ── TABS ── */}
      <div className="cd-tabs">
        {TOP_TABS.map((tab) => (
          <button
            key={tab.key}
            className={`cd-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="cd-body">

        {/* ═══════════ VISÃO GERAL ═══════════ */}
        {activeTab === 'visao' && (
          <div className="cd-grid-2">
            <div className="cd-col">
              {camp.edital && (
                <div className="cd-card">
                  <h3>📄 Edital</h3>
                  <pre className="cd-pre">{camp.edital}</pre>
                  {camp.regulamento_url && (
                    <a href={camp.regulamento_url} target="_blank" rel="noopener noreferrer" className="cd-link">📎 Ver regulamento completo</a>
                  )}
                </div>
              )}
              {camp.regras && (
                <div className="cd-card">
                  <h3>📜 Regras específicas</h3>
                  <pre className="cd-pre">{camp.regras}</pre>
                </div>
              )}
              {(camp.info_checkin || camp.info_pesagem) && (
                <div className="cd-card">
                  <h3>🚪 Check-in & Pesagem</h3>
                  {camp.info_checkin && <p className="cd-p"><b>Check-in:</b> {camp.info_checkin}</p>}
                  {camp.info_pesagem && <p className="cd-p"><b>Pesagem:</b> {camp.info_pesagem}</p>}
                </div>
              )}
              {!camp.edital && !camp.regras && !camp.info_checkin && (
                <div className="empty-state">
                  <h4>Nenhuma informação de edital ainda</h4>
                  <p>Preencha o edital, regras e logística na aba Editar.</p>
                </div>
              )}
            </div>

            <div className="cd-col">
              <div className="cd-card">
                <h3>💰 Lotes de inscrição</h3>
                {lotes.length === 0 && <p className="ed-hint">Nenhum lote configurado.</p>}
                {lotes.map((l, i) => (
                  <div key={i} className="cd-row">
                    <span>{l.nome}{l.data_limite ? ` · até ${fmtData(l.data_limite)}` : ''}</span>
                    <b>{fmtMoeda(l.valor)}</b>
                  </div>
                ))}
              </div>

              {premiacoes.length > 0 && (
                <div className="cd-card">
                  <h3>🏆 Premiações</h3>
                  {premiacoes.map((p, i) => (
                    <div key={i} className="cd-row">
                      <span>{p.colocacao}</span>
                      <b>{p.premio}</b>
                    </div>
                  ))}
                </div>
              )}

              {(camp.contato_whatsapp || camp.contato_email || camp.chave_pix) && (
                <div className="cd-card">
                  <h3>📞 Contato & Pagamento</h3>
                  {camp.contato_whatsapp && <p className="cd-p">💬 {camp.contato_whatsapp}</p>}
                  {camp.contato_email && <p className="cd-p">📧 {camp.contato_email}</p>}
                  {camp.contato_instagram && <p className="cd-p">📸 {camp.contato_instagram}</p>}
                  {camp.chave_pix && <p className="cd-p">💳 PIX: <code>{camp.chave_pix}</code></p>}
                  {formasPagamento.length > 0 && <p className="cd-p">Formas: {formasPagamento.join(', ')}</p>}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ═══════════ INSCRIÇÕES ═══════════ */}
        {activeTab === 'inscricoes' && (
          <div className="ed-section">
            {inscritos.length === 0 && (
              <div className="empty-state">
                <h4>Nenhuma inscrição ainda</h4>
                <p>As inscrições feitas pelo site institucional aparecem aqui.</p>
              </div>
            )}
            {inscritos.length > 0 && (
              <div style={{ overflowX: 'auto' }}>
                <table className="data-table ed-insc-table">
                  <thead>
                    <tr>
                      <th>Atleta</th><th>Categoria(s)</th><th>Responsável</th><th>Valor</th><th>Status</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {inscritos.map((i) => (
                      <tr key={i.id}>
                        <td>
                          <div className="ed-insc-atleta" style={{ '--faixa-cor': CORES_FAIXA[i.faixa] || 'var(--line)' }}>
                            <span className="ed-insc-avatar">{iniciais(i.aluno_nome)}</span>
                            <div><b>{i.aluno_nome}</b>{i.faixa && <small>Faixa {i.faixa}</small>}</div>
                          </div>
                        </td>
                        <td>{(i.categorias || []).map((c) => c.categoria_nome).join(', ')}</td>
                        <td>{i.usuario_nome}<br /><small>{i.usuario_email}</small></td>
                        <td className="ed-insc-valor">{fmtMoeda(i.valor_total)}</td>
                        <td>
                          <span className={`badge ${i.status === 'confirmada' ? 'badge-open' : i.status === 'cancelada' ? 'badge-closed' : 'badge-pending'}`}>
                            {i.status === 'confirmada' ? 'Confirmada' : i.status === 'cancelada' ? 'Cancelada' : 'Pendente'}
                          </span>
                        </td>
                        <td>
                          {i.status === 'pendente_pagamento' && (
                            <button className="btn-primary" style={{ padding: '6px 12px', fontSize: 12.5 }} onClick={() => handleConfirmarPagamento(i.id)} disabled={confirmandoId === i.id}>
                              {confirmandoId === i.id ? 'Confirmando…' : 'Confirmar pagamento'}
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ═══════════ FINANCEIRO ═══════════ */}
        {activeTab === 'financeiro' && (
          <div className="ed-section">
            <div className="fin-kpi-row">
              <div className="fin-kpi fin-kpi-green">
                <span className="fin-kpi-label">Receita confirmada</span>
                <span className="fin-kpi-value">{fmtMoeda(receitaConfirmada)}</span>
                <span className="fin-kpi-sub">{confirmadas.length} inscrição{confirmadas.length === 1 ? '' : 'ões'} paga{confirmadas.length === 1 ? '' : 's'}</span>
              </div>
              <div className="fin-kpi fin-kpi-amber">
                <span className="fin-kpi-label">Receita pendente</span>
                <span className="fin-kpi-value">{fmtMoeda(receitaPendente)}</span>
                <span className="fin-kpi-sub">{pendentes.length} aguardando confirmação</span>
              </div>
              <div className="fin-kpi">
                <span className="fin-kpi-label">Ticket médio</span>
                <span className="fin-kpi-value">{fmtMoeda(ticketMedio)}</span>
                <span className="fin-kpi-sub">por inscrição confirmada</span>
              </div>
              <div className="fin-kpi">
                <span className="fin-kpi-label">Canceladas</span>
                <span className="fin-kpi-value">{canceladas.length}</span>
                <span className="fin-kpi-sub">inscrições canceladas</span>
              </div>
            </div>

            {Object.keys(porFormaPagamento).length > 0 && (
              <div className="cd-card">
                <h3>Formas de pagamento</h3>
                {Object.entries(porFormaPagamento).sort((a, b) => b[1] - a[1]).map(([forma, total]) => (
                  <div key={forma} className="fin-forma-row">
                    <div className="fin-forma-label"><span>{forma}</span><b>{fmtMoeda(total)}</b></div>
                    <div className="fin-bar-track fin-bar-track-sm">
                      <div className="fin-bar-fill fin-bar-confirmada" style={{ width: `${(total / totalPorForma) * 100}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══════════ CATEGORIAS ═══════════ */}
        {activeTab === 'categorias' && (
          <div className="ed-section">
            <p className="ed-hint">Categorias com pelo menos uma inscrição confirmada neste campeonato. Categorias com 3+ já podem ter chave gerada.</p>
            {categoriasComInscritos.length === 0 && (
              <div className="empty-state">
                <h4>Nenhuma categoria com inscritos confirmados</h4>
                <p>Confirme pagamentos na aba Inscrições para ver categorias aqui.</p>
              </div>
            )}
            <div className="cd-cat-grid">
              {categoriasComInscritos.map((cat) => {
                const pronta = cat.confirmados >= 3;
                const jaTemChave = chaveJaExiste(cat.id, '');
                return (
                  <div key={cat.id} className={`cd-cat-card ${pronta ? 'pronta' : ''}`}>
                    <h4>{cat.nome}</h4>
                    <div className="cd-cat-count">{cat.confirmados} confirmado{cat.confirmados === 1 ? '' : 's'}</div>
                    {jaTemChave ? (
                      <span className="badge badge-open">✓ chave gerada</span>
                    ) : pronta ? (
                      <button className="btn-primary" style={{ padding: '6px 12px', fontSize: 12.5 }} onClick={() => { setGerarCategoriaId(cat.id); setActiveTab('chaves'); }}>
                        Gerar chave →
                      </button>
                    ) : (
                      <span className="ed-hint">faltam {3 - cat.confirmados} para gerar chave</span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ═══════════ CHAVES ═══════════ */}
        {activeTab === 'chaves' && (
          <div className="ed-section">
            <div className="cd-card">
              <h3>Gerar nova chave</h3>
              <div className="ed-field-row">
                <div className="ed-field">
                  <label>Categoria</label>
                  <select value={gerarCategoriaId} onChange={(e) => { setGerarCategoriaId(e.target.value); setGerarFaixa(''); }}>
                    <option value="">Selecione uma categoria</option>
                    {categorias.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                  </select>
                </div>
                {faixasDaCategoria.length > 0 && (
                  <div className="ed-field">
                    <label>Faixa (opcional)</label>
                    <select value={gerarFaixa} onChange={(e) => setGerarFaixa(e.target.value)}>
                      <option value="">Todas as faixas</option>
                      {faixasDaCategoria.map((f) => <option key={f} value={f}>{f}</option>)}
                    </select>
                  </div>
                )}
              </div>
              {gerarCategoriaId && (
                <p className="ed-hint">
                  {atletasDisponiveis.length} atleta{atletasDisponiveis.length === 1 ? '' : 's'} confirmado{atletasDisponiveis.length === 1 ? '' : 's'} nessa combinação
                  {chaveJaExiste(gerarCategoriaId, gerarFaixa) ? ' — chave já existe para essa combinação.' : atletasDisponiveis.length < 3 ? ' — mínimo de 3 para gerar.' : '.'}
                </p>
              )}
              <button
                className="btn-primary"
                disabled={!gerarCategoriaId || atletasDisponiveis.length < 3 || gerando || chaveJaExiste(gerarCategoriaId, gerarFaixa)}
                onClick={handleGerarChave}
              >
                {gerando ? 'Gerando…' : 'Sortear e gerar chave'}
              </button>
            </div>

            <div className="cd-card">
              <h3>Chaves geradas ({chaves.length})</h3>
              {chaves.length === 0 && <p className="ed-hint">Nenhuma chave gerada neste campeonato ainda.</p>}
              <div className="cd-chave-grid">
                {chaves.map((chave) => (
                  <div key={chave.id} className="cd-chave-card">
                    <div className="cd-chave-top">
                      {chave.codigo_chave && <span className="cd-chave-codigo">#{chave.codigo_chave}</span>}
                      <span>Chave de {chave.tamanho}</span>
                    </div>
                    <b>{chave.categoria_nome}</b>
                    {chave.faixa && <span className="ed-hint">Faixa {chave.faixa}</span>}
                    <span className="ed-hint">{chave.num_atletas} atletas</span>
                    <div className="cd-chave-actions">
                      <button className="btn-primary" style={{ padding: '6px 10px', fontSize: 12 }} onClick={() => handleVerChave(chave)}>👁️ Ver</button>
                      <button className="btn-primary" style={{ padding: '6px 10px', fontSize: 12 }} onClick={() => handleBaixarChave(chave)}>📄 Baixar</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ═══════════ CRONOGRAMA ═══════════ */}
        {activeTab === 'cronograma' && (
          <div className="ed-section">
            <p className="ed-hint">Horários e atividades do dia do evento.</p>
            {cronograma.map((item, idx) => (
              <div key={idx} className="ed-list-item">
                <div className="ed-list-item-body">
                  <div className="ed-field ed-field-small">
                    <label>⏰ Horário</label>
                    <input type="text" value={item.horario} onChange={(e) => { const arr = [...cronograma]; arr[idx].horario = e.target.value; setCronograma(arr); }} placeholder="08:00" />
                  </div>
                  <div className="ed-field">
                    <label>📝 Descrição</label>
                    <input type="text" value={item.descricao} onChange={(e) => { const arr = [...cronograma]; arr[idx].descricao = e.target.value; setCronograma(arr); }} placeholder="Ex: Abertura das inscrições e check-in" />
                  </div>
                </div>
                <button className="ed-remove-item" onClick={() => setCronograma(cronograma.filter((_, i) => i !== idx))}>✕</button>
              </div>
            ))}
            <button className="ed-add-btn" onClick={() => setCronograma([...cronograma, { horario: '', descricao: '' }])}>+ Adicionar Item ao Cronograma</button>
          </div>
        )}

        {/* ═══════════ EDITAR ═══════════ */}
        {activeTab === 'editar' && (
          <>
            <div className="cd-subtabs">
              {EDIT_SUBTABS.map((t) => (
                <button key={t.key} className={`cd-subtab ${editSubTab === t.key ? 'active' : ''}`} onClick={() => setEditSubTab(t.key)}>
                  {t.label}
                </button>
              ))}
            </div>

            {editSubTab === 'dados' && (
              <div className="ed-section">
                <div className="ed-field">
                  <label>🏅 Nome do Campeonato <span className="required">*</span></label>
                  <input type="text" name="nome" value={form.nome} onChange={handleChange} placeholder="Ex: Circuito Carioca de Jiu-Jitsu" />
                </div>
                <div className="ed-field-row">
                  <div className="ed-field"><label>📅 Data de Início</label><input type="date" name="data_inicio" value={form.data_inicio} onChange={handleChange} /></div>
                  <div className="ed-field"><label>📅 Data de Fim</label><input type="date" name="data_fim" value={form.data_fim} onChange={handleChange} /></div>
                </div>
                <div className="ed-field"><label>📍 Local (Ginásio / Clube)</label><input type="text" name="local" value={form.local} onChange={handleChange} placeholder="Ex: Ginásio Maracanãzinho" /></div>
                <div className="ed-field-row">
                  <div className="ed-field"><label>🏙️ Cidade</label><input type="text" name="cidade" value={form.cidade} onChange={handleChange} placeholder="Ex: Rio de Janeiro" /></div>
                  <div className="ed-field ed-field-small"><label>🗺️ Estado (UF)</label><input type="text" name="estado" value={form.estado} onChange={handleChange} placeholder="RJ" maxLength="2" /></div>
                </div>
              </div>
            )}

            {editSubTab === 'capa' && (
              <div className="ed-section">
                <div className="ed-capa-preview">
                  {capaPreview ? <img src={capaPreview} alt="Capa atual" className="ed-capa-img" /> : (
                    <div className="ed-capa-empty"><span>🖼️</span><p>Nenhuma capa definida</p></div>
                  )}
                </div>
                <label className="ed-upload-btn">
                  📎 {capaPreview ? 'Trocar Imagem de Capa' : 'Selecionar Capa'}
                  <input type="file" accept="image/*" onChange={handleCapaChange} hidden />
                </label>
                {capaPreview && <button className="ed-remove-capa" onClick={() => { setCapaFile(null); setCapaPreview(''); }}>🗑️ Remover Capa</button>}
                <p className="ed-hint">Formatos aceitos: JPG, PNG, WEBP. Tamanho máximo: 5MB.</p>
              </div>
            )}

            {editSubTab === 'premiacoes' && (
              <div className="ed-section">
                <p className="ed-hint">Defina as premiações e reconhecimentos do evento.</p>
                {premiacoes.map((p, idx) => (
                  <div key={idx} className="ed-list-item">
                    <div className="ed-list-item-body">
                      <div className="ed-field"><label>🥇 Colocação</label><input type="text" value={p.colocacao} onChange={(e) => { const arr = [...premiacoes]; arr[idx].colocacao = e.target.value; setPremiacoes(arr); }} placeholder="Ex: 1º Lugar" /></div>
                      <div className="ed-field"><label>🎁 Prêmio</label><input type="text" value={p.premio} onChange={(e) => { const arr = [...premiacoes]; arr[idx].premio = e.target.value; setPremiacoes(arr); }} placeholder="Ex: Medalha de Ouro" /></div>
                    </div>
                    <button className="ed-remove-item" onClick={() => setPremiacoes(premiacoes.filter((_, i) => i !== idx))}>✕</button>
                  </div>
                ))}
                <button className="ed-add-btn" onClick={() => setPremiacoes([...premiacoes, { colocacao: '', premio: '' }])}>+ Adicionar Premiação</button>
              </div>
            )}

            {editSubTab === 'lotes' && (
              <div className="ed-section">
                <p className="ed-hint">Configure os lotes de inscrição com seus valores.</p>
                {lotes.map((l, idx) => (
                  <div key={idx} className="ed-list-item">
                    <div className="ed-list-item-body">
                      <div className="ed-field"><label>📦 Nome do Lote</label><input type="text" value={l.nome} onChange={(e) => { const arr = [...lotes]; arr[idx].nome = e.target.value; setLotes(arr); }} placeholder="Ex: Lote 1 — Antecipado" /></div>
                      <div className="ed-field ed-field-small"><label>💲 Valor (R$)</label><input type="number" value={l.valor} onChange={(e) => { const arr = [...lotes]; arr[idx].valor = parseFloat(e.target.value); setLotes(arr); }} placeholder="140.00" min="0" step="0.01" /></div>
                      <div className="ed-field ed-field-small"><label>⏳ Válido até</label><input type="date" value={l.data_limite || ''} onChange={(e) => { const arr = [...lotes]; arr[idx].data_limite = e.target.value; setLotes(arr); }} /></div>
                    </div>
                    <button className="ed-remove-item" onClick={() => setLotes(lotes.filter((_, i) => i !== idx))}>✕</button>
                  </div>
                ))}
                <button className="ed-add-btn" onClick={() => setLotes([...lotes, { nome: '', valor: 0, data_limite: '' }])}>+ Adicionar Lote</button>
                <p className="ed-hint" style={{ marginTop: 10 }}>Deixe "Válido até" em branco para um lote sem prazo (fica sempre disponível). Se houver mais de um lote com prazo, o sistema usa automaticamente o primeiro que ainda não venceu.</p>
              </div>
            )}

            {editSubTab === 'edital' && (
              <div className="ed-section">
                <div className="ed-field"><label>📄 Edital Oficial</label><textarea name="edital" value={form.edital} onChange={handleChange} rows={12} placeholder="Digite o edital completo do campeonato. Inclua: regulamento, categorias, regras de pesagem, premiação etc." /></div>
                <div className="ed-field"><label>🔗 Link do Regulamento (PDF)</label><input type="url" name="regulamento_url" value={form.regulamento_url} onChange={handleChange} placeholder="https://drive.google.com/... ou link do PDF" /><p className="ed-hint">Cole aqui o link para o PDF do edital completo.</p></div>
                <div className="ed-field"><label>📜 Regras Específicas</label><textarea name="regras" value={form.regras} onChange={handleChange} rows={6} placeholder="Regras específicas do evento, critérios de desempate, condutas etc." /></div>
                <div className="ed-field"><label>💬 Observações Gerais</label><textarea name="observacoes" value={form.observacoes} onChange={handleChange} rows={4} placeholder="Informações adicionais importantes para os atletas." /></div>
              </div>
            )}

            {editSubTab === 'contato' && (
              <div className="ed-section">
                <p className="ed-hint">Informe como os atletas podem entrar em contato com os organizadores.</p>
                <div className="ed-field"><label>💬 WhatsApp do Organizador</label><input type="text" name="contato_whatsapp" value={form.contato_whatsapp} onChange={handleChange} placeholder="5521999998888 (somente números com DDI+DDD)" /><p className="ed-hint">Será exibido como botão de contato direto para o atleta.</p></div>
                <div className="ed-field"><label>📧 E-mail de Contato</label><input type="email" name="contato_email" value={form.contato_email} onChange={handleChange} placeholder="contato@campeonato.com.br" /></div>
                <div className="ed-field"><label>📸 Instagram</label><input type="text" name="contato_instagram" value={form.contato_instagram} onChange={handleChange} placeholder="@seuinstagram" /></div>
                <div className="ed-field"><label>🌐 Site Oficial</label><input type="url" name="site_oficial" value={form.site_oficial} onChange={handleChange} placeholder="https://www.seusite.com.br" /></div>
                <div className="ed-field"><label>💳 Chave PIX para Pagamento</label><input type="text" name="chave_pix" value={form.chave_pix} onChange={handleChange} placeholder="CPF, CNPJ, e-mail ou chave aleatória" /></div>
                <div className="ed-field">
                  <label>💰 Formas de Pagamento Aceitas</label>
                  <div className="ed-checkbox-group">
                    {FORMAS_PAG_TODAS.map((fp) => (
                      <label key={fp} className="ed-checkbox-label">
                        <input type="checkbox" checked={formasPagamento.includes(fp)} onChange={(e) => { if (e.target.checked) setFormasPagamento([...formasPagamento, fp]); else setFormasPagamento(formasPagamento.filter((f) => f !== fp)); }} />
                        {fp}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {editSubTab === 'logistica' && (
              <div className="ed-section">
                <div className="ed-field"><label>🚪 Check-in</label><textarea name="info_checkin" value={form.info_checkin} onChange={handleChange} rows={4} placeholder="Ex: Check-in das 07h às 09h no Ginásio Principal. Apresentar documento com foto." /></div>
                <div className="ed-field"><label>⚖️ Pesagem</label><textarea name="info_pesagem" value={form.info_pesagem} onChange={handleChange} rows={4} placeholder="Ex: Pesagem ocorre no dia do evento antes das lutas. Tolerância de 0,1kg." /></div>
                <div className="ed-field"><label>👥 Limite de Inscrições</label><input type="number" name="limite_inscricoes" value={form.limite_inscricoes} onChange={handleChange} placeholder="Ex: 500" min="0" /><p className="ed-hint">Deixe em branco para não ter limite de atletas.</p></div>
                <p className="ed-hint">O cronograma do evento tem aba própria — veja "🗓 Cronograma" no menu acima.</p>
              </div>
            )}

            {editSubTab === 'config' && (
              <div className="ed-section">
                <div className="ed-field">
                  <label>🚦 Status do Campeonato</label>
                  <div className="ed-status-selector">
                    {STATUS_OPTIONS.map((opt) => (
                      <button key={opt.value} className={`ed-status-option ${form.status === opt.value ? 'selected' : ''}`} style={{ '--status-color': opt.color }} onClick={() => setForm((prev) => ({ ...prev, status: opt.value }))}>
                        {opt.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="ed-field" style={{ marginTop: '24px' }}>
                  <label>⚖️ Tabela de Pesos Vinculada</label>
                  <select name="tabela_peso_id" value={form.tabela_peso_id} onChange={handleChange}>
                    <option value="">— Nenhuma tabela vinculada —</option>
                    {tabelasPeso.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
                  </select>
                  <p className="ed-hint">A tabela define as categorias de peso disponíveis para inscrição.</p>
                </div>
                <div className="ed-hint" style={{ marginTop: '8px' }}>Precisa excluir este campeonato? Use o botão 🗑️ Excluir no topo do painel.</div>
              </div>
            )}
          </>
        )}
      </div>

      {mostrarBarraSalvar && (
        <div className="ed-footer cd-footer">
          <button className="ed-btn-cancel" onClick={carregarTudo} disabled={saving}>Descartar alterações</button>
          <button className="ed-btn-save" onClick={handleSave} disabled={saving}>{saving ? '⏳ Salvando...' : '💾 Salvar Alterações'}</button>
        </div>
      )}
    </div>
  );
}

export default CampeonatoDetalhe;
